<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">车牌号码</span>
        <el-input placeholder="请输入关键词" v-model="conditions.plate" clearable>
        </el-input>
        <span class="fonints">司机姓名</span>
        <el-input placeholder="请输入关键词" v-model="conditions.driverName" clearable>
        </el-input>
        <span class="fonints">车辆所有人</span>
        <el-input placeholder="请输入关键词" v-model="conditions.carowner" clearable>
        </el-input>
        <button class="buttons" @click="selectlist">查询</button>
      </div>
      <div class="componentSty_content_table" style="border:none">
        <el-table :data="arrlist.list" style="width: 100%; height: 80%" height="80%" border @sort-change="sortchange">
           <el-table-column show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" label="申请时间" prop="gmt_create">
            <template v-slot="res">
              {{ dateFormat(res.row.gmtCreate) }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="plate" label="车牌号码"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="hangPlate" label="挂车号码"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="driverName" label="司机姓名">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="telephone" label="手机号码"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="carowner"  :render-header="renderHeader" label="车辆所有人">
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作">
            <template v-slot="res">
              <button class="buttons" style="background: orange; height: 25px" @click="itemparticulars(res.row)">
                发卡
              </button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.list && arrlist.list.length">
          <el-pagination :page-size="conditions.limit" layout="total,prev, pager,next, jumper"
            :total="arrlist.totalCount" :current-page="conditions.page" @current-change="getMemberlist">
          </el-pagination>
        </div>
        <m-dialog :isShow="addrole" width="700px" @changeState="sendMsg" title="发卡">
          <div class="inForMsgBox">
            <div class="itemBox" style="width: 100%">
              <span class="key" style="width: 15%; text-align: left">车牌号码</span>
              <div class="val" style="width: 78%">
                {{ tuckcomb.plate }}
              </div>
            </div>
            <div class="itemBox" style="width: 100%">
              <span class="key" style="width: 15%; text-align: left">会员卡号:</span>
              <div class="val" style="width: 78%; background: #f3f4f5">
                <m-superIpt v-model.lazy="tuckcomb.sn" defaultInfo="请输入会员卡号" :readonly="readonly"></m-superIpt>
              </div>
            </div>
            <div class="itemBox" style="width: 100%">
              <span class="key" style="width: 15%; text-align: left">RFID号</span>
              <div class="val" style="width: 58%; background: #f3f4f5">
                <m-superIpt v-model="tuckcomb.rfid" defaultInfo="请输入RFID号" :readonly="readonly"></m-superIpt>
              </div>
              <button class="buttons" style="background: orange; width: 17%; vertical-align: middle" @click="readcard">
                清空
              </button>
            </div>
            <div class="itemBox" style="width: 100%">
             
            </div>
          </div>
        </m-dialog>
        <!-- 添加角色对话框 -->
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mDialog from "@/components/mDialog";
import mSuperIpt from "@/components/mSuperIpt";
import mSelect from "@/components/mSelect";
import { antiShake, wsReadCard, getConnection, readRFIDcard_new } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      connState: 1,
      isReading: false,//读卡状态 。
      listitem: [{ name: "会员管理" }, { name: "发卡申请" }],
      isloding: false,
      readonly: false,
      btnmsg: "读卡",
      conditions: {
        page: 1,
        limit: 20,
        order: "desc",
        sidx: "gmt_create",
      },
      arrlist: [],
      tuckcomb: {
        plate: "",
        rfid: "",
        sn: "", //会员卡号
      },
      idcard: "",
      addrole: false,
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  // watch: {
  //   idcard(nval) {
  //     if (nval == "读卡器打开成功!" || nval === "读卡器连接异常!" || !nval)
  //       return "";
  //     this.tuckcomb.sn = "";
  //     this.tuckcomb.rfid = nval;
  //     this.getuserCard();
  //   },
  // },
  components: {
    mTitle,
    mDialog,
    mSuperIpt,
    mSelect,
  },
  created() {
    // this.conditionsList[this.$route.path] ||
    //   this.createConditions({
    //     key: this.$route.path,
    //     val: {
    //       page: 1,
    //       limit: 20,
    //       order: "desc",
    //       sidx: "gmt_create",
    //     },
    //   });
    // this.conditions = this.conditionsList[this.$route.path] || {
    //   page: 1,
    //   limit: 20,
    //   order: "desc",
    //   sidx: "gmt_create",
    // };
    this.getMemberlist();
  },
  methods: {
    ...mapMutations(["createConditions"]),
    dateFormat(obj) {
      if (!obj) return "";
      let dt = new Date(obj),
        yy = dt.getFullYear(),
        mon = (dt.getMonth() + 1 + "").padStart(2, 0),
        dd = (dt.getDate() + "").padStart(2, 0),
        hh = (dt.getHours() + "").padStart(2, 0),
        min = (dt.getMinutes() + "").padStart(2, 0);
      return `${yy}-${mon}-${dd} ${hh}:${min}`;
    },
    async getMemberlist(num) {
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/driver/car/webCardIssuancelist",
        "get",
        this.conditions
      );
      if (!data || data.code != 0) return this.$message.error("获取数据失败");
      this.arrlist = data.page;
    },
    async itemparticulars(res) {
      this.readcard()
      antiShake((_) => {
        this.tuckcomb.plate = res.plate;
        this.addrole = true;
      });
    },
    // 清空
    async readcard() {
      this.idcard = "";
      this.tuckcomb.sn = "";
      this.tuckcomb.rfid = "";
    },
    // 获取会员卡号
    async getuserCard() {
      const { data } = await this.$http(
        "api1",
        "/driver/rfid/getCardInfoByRfid ",
        "post",
        {
          rfid: this.tuckcomb.rfid,
        }
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.tuckcomb.sn = data.data.sn;
    },
    async sendMsg(item) {
      if (item != "confirm") {
        return (this.addrole = false);
      }
      let isok = !this.tuckcomb.rfid || !this.tuckcomb.sn;
      if (isok) return this.$message.error("必填项不能为空");
      const { data } = await this.$http(
        "api1",
        "/driver/rfid/cardIssuance",
        "post",
        this.tuckcomb
      );
      if (data.code != 0) return this.$message.error("发卡失败");
      this.addrole = false;
      this.$notification({
        title: `${this.tuckcomb.plate}`,
        message: `发卡成功`,
        type: "success",
        position: "bottom-left",
        duration: 5000,
      });
      this.getMemberlist();
    },
    
    sortchange(event) {
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      this.getMemberlist();
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getMemberlist();
      });
    },
  },
  beforeDestroy() {
    window.ws && window.ws.close();
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped>
</style>